// extracted by mini-css-extract-plugin
export default {"cum":"Tuscartas_cum__riPxR","cumas1":"Tuscartas_cumas1__B-lG6","cumpas2":"Tuscartas_cumpas2__8rAOw"};